import React from 'react'

import { Button, TextField } from '@material-ui/core/'
import InviteInternal from './InviteInternal'

class FacebookFriend extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      cooknFacebookUser: props.friend.cooknData,
      isFriend: false
    }
  }

  render() {
    const isFriend = false
    const cooknFacebookUser = this.state.cooknFacebookUser
    console.log("render: name=[" + this.props.friend.name + "]")

    //{name: "Jane Doe", id: "107510094221924"}

    let cooknUserInvite = ''

    let name = ''

    if (this.props.friend.name !== '') {
      name = this.props.friend.name
    }

    if (cooknFacebookUser !== undefined && isFriend === false) {
      // If we have a Cook'n user associated with the Facebook user
      // And this user isn't a friend
      // Then we can show the internal invite button
      const internalInvite = (
        <InviteInternal
          aid={this.props.aid}
          firstName={name} // We only have a combined name, but it will be formatted ok so we can just put it in the First Name slot
          lastName=""
          fid={cooknFacebookUser.accountId}
          sendInternalInvite={this.props.sendInternalInvite}
        />
      )

      cooknUserInvite = <span className="userContacts">{internalInvite}</span>
    }

    if (cooknUserInvite !== '') {
      return <li className="contact-container">{cooknUserInvite}</li>
    } else {
      return ''
    }
  }
}


export default FacebookFriend



// WEBPACK FOOTER //
// ./src/Components/FacebookFriend.js